import {
  AppBar,
  Box,
  styled,
  Theme,
  Toolbar,
  useMediaQuery,
} from "@mui/material";
import { H2 } from "components/Typography";
import { TitleContext } from "contexts/TitleContext";
import { FC, useContext } from "react";
import InstallAppButton from "components/InstallAppButton";
import ProfilePopover from "./popovers/ProfilePopover";

// root component interface
interface DashboardNavBarProps {
  setShowMobileSideBar: () => void;
}

// custom styled components
const DashboardNavbarRoot = styled(AppBar)(() => ({
  zIndex: 11,
  boxShadow: "none",
  paddingTop: "1rem",
  paddingBottom: "1rem",
  backgroundColor: "#ffffff",
}));

const StyledToolBar = styled(Toolbar)(() => ({
  "@media (min-width: 0px)": {
    paddingLeft: 0,
    paddingRight: 0,
    minHeight: "auto",
  },
}));

// root component
const DashboardNavbar: FC<DashboardNavBarProps> = ({
  setShowMobileSideBar,
}) => {
  const { title } = useContext(TitleContext);
  const downMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  if (downMd) {
    return (
      <DashboardNavbarRoot
        style={{ backgroundColor: "#ffffff" }}
        position="sticky"
      >
        <StyledToolBar>
          <Box flexGrow={1} textAlign="start">
            <H2 lineHeight={0} mx={1} fontWeight="bold" color="text.primary">
              {title}
            </H2>
          </Box>
          <InstallAppButton />
          <ProfilePopover />
        </StyledToolBar>
      </DashboardNavbarRoot>
    );
  }

  return (
    <DashboardNavbarRoot position="sticky">
      <StyledToolBar>
        <H2 lineHeight={0} mx={1} fontWeight="bold" color="text.primary">
          {title}
        </H2>
        <Box flexGrow={1} ml={1} />
        <InstallAppButton />
        <ProfilePopover />
      </StyledToolBar>
    </DashboardNavbarRoot>
  );
};

export default DashboardNavbar;
